module.exports = __webpack_public_path__ + "static/media/visa-logo.88255450.jpg";